import { FC } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Typography } from '@altermaind/web/ui';

export const EmptyState: FC = () => {
  const t = useTranslations('settings.tabs.credits.noData');

  return (
    <Box textAlign='center' mt='xl'>
      <Typography variant='h2' mb='xs'>
        {t('title')}
      </Typography>
      <Typography variant='p3/light' mb='m'>
        {t('description')}
      </Typography>
    </Box>
  );
};
